import { useState } from "react";
import backArrow from "../../../../assets/VZY/backArrow.png";
import searchIcon from "../../../../assets/VZY/mobile-search-icon.svg";
import { useNavigate } from "react-router-dom";
import { SearchBox } from "./SearchBox";
import { BrowserView, MobileView } from "react-device-detect";

const truncateText = (text, maxLength = 20) => {
  if (!text) return "";
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const InnerSearch = ({ innerSearch }) => {
  const navigate = useNavigate();
  const { pageName, breadcrumb } = innerSearch;
  const [showSearch, setShowSearch] = useState(false);

  const backBtn = (pageName) => {
    if (pageName === "Search Results for") {
      navigate(-2);
    } else {
      navigate(-1);
    }
  };

  const handleBreadcrumbClick = (item, index) => {
    if (item.url && index < breadcrumb.length - 1) {
      navigate(item.url);
    }
  };

  return (
    <div className="search-wrapper">
      <div className="container">
        <div className="page-scroll-search-wrapper">
          <div className="inner-title">
            <h3>
              <img
                src={backArrow}
                alt="back"
                onClick={() => backBtn(pageName)}
              />
              {pageName}
            </h3>

            <BrowserView>
              <span className="breadcrumb-box">
                {breadcrumb.map((item, index) => {
                  const isLast = index === breadcrumb.length - 1;
                  const isClickable = item.url && !isLast;

                  return (
                    <span key={index}>
                      <span
                        title={item?.label}
                        onClick={() => handleBreadcrumbClick(item, index)}
                        style={{
                          cursor: isClickable ? "pointer" : "default",
                        }}
                      >
                        {truncateText(item?.label, 20)}
                      </span>
                      {index < breadcrumb.length - 1 && " > "}
                    </span>
                  );
                })}
              </span>
            </BrowserView>

            <MobileView>
              <span className="search-toggle">
                <img
                  src={searchIcon}
                  alt="Search"
                  onClick={() => setShowSearch((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </MobileView>
          </div>

          {showSearch && (
            <div className="search-scroll-row">
              <SearchBox />
            </div>
          )}

          <BrowserView>
            <div className="search-scroll-row">
              <SearchBox />
            </div>
          </BrowserView>
        </div>
      </div>
    </div>
  );
};
